export const HOTEL = 'hotel';
export const DASHBOARD = 'dashboard';
export const RESERVATION = 'reservation';
export const SEARCH_RESERVATION = 'search_reservation';
export const ACTION = 'action';
export const READ = 'read';
export const WRITE = 'write';
export const UPDATE = 'update';
export const DESTROY = 'destroy';
export const NOTE = 'note';
export const COMPLETE = 'complete';
export const CREATE_RESERVATION = 'create_reservation';
export const SUMMARY = 'summary';
export const BOOK = 'book';
export const PAY = 'pay';
export const FORECAST = 'forecast';
export const GUEST = 'guest';
export const FINANCIAL_ACCOUNT = 'financial_account';
export const GROUP_RESERVATION = 'group_reservation';
export const GROUPS = 'groups';
export const FRONT_DESK = 'front_desk';
export const ARRIVAL = 'arrival';
export const DEPARTURE = 'departure';
export const IN_HOUSE = 'in_house';
export const ROOM_PLAN = 'room_plan';
export const CONCIERGE = 'concierge';
export const CASHIER = 'cashier';
export const CASH_REGISTER = 'cash_register';
export const EXCHANGE = 'exchange';
export const RATE_EXCHANGE = 'rate_exchange';
export const BILLING = 'billing';
export const REVENU_MANAGEMENT = 'revenu_management';
export const COMPANY_TA_CARDS = 'compagy_ta_cards';
export const RATES = 'rates';
export const RATE_MANAGER = 'rate_manager';
export const PROMOS = 'promos';
export const END_OF_DAY_CHECK = 'end_of_day_check';
export const FLASH_MANAGER = 'flash_manager';
export const TRIAL_BALANCE = 'trial_balance';
export const AGENCY_PERFERMANCE_OVERVIEW = 'agency_perfermance_overview';
export const HOUSE_KEEPING = 'house_keeping';
export const HOUSE_KEEPING_ROOM_STATUS = 'house_keeping_roomStatus';
export const HOUSE_KEEPING_WORK_MANAGEMENT = 'house_keeping_workManagement';
export const MAINTENANCE = 'maintenance';
export const FINANCIAL = 'financial';
export const AR_ACCOUNT = 'ar_account';
export const REPORT = 'report';
export const SETTINGS = 'settings';
export const PROPERTY_AND_STAFF = 'proporty_and_staff';
export const ROOMS = 'rooms';
export const TRANSFER_EXCURSION = 'transfer_excursion';
export const RATES_PROMO = 'rates_promo';
export const CARDS = 'cards';
export const APPLICATION_SETTINGS = 'application_settings';
export const ACL = 'acl';
export const DAILY_FORECAST = 'daily_forecast';
export const FORECAST_BY_ROOM_TYPE = 'forecast_by_room_type';
export const FOUR_WEEK_FORECAST = 'four_week_forecast';
export const RESERVATION_LIST = 'reservation_list';
export const NATIONALITY_FORECAST = 'nationality_forecast';
export const DAILY_REPORT = 'daily_report';
export const LOGS = 'logs';
export const ROOM_STATE = 'room_state';
export const TRANSACTIONS_LIST = 'transactions_list';
export const PRE_PAYMENT = 'pre_payment';
export const ROOM_MOVE = 'room_move';
export const ACCOUNTS_RECEIVABLE_SALES_JOURNAL = 'accounts_receivable_sales_journal';
export const NIGHT_AUDIT = 'night_audit';
export const PAYMENT_METHODS = 'payment_methods';
export const CURRENCY = 'currency';
export const PAYMENT = 'payment';
export const PAYMENT_GROUP = 'payment_group';
export const CASH_OPERATION_REGISTER = 'cash_operation_register';
export const CASH_CATEGORY = 'cash_category';
export const ACCOUNT_GROUP = 'account_group';
export const ACCOUNT_NUMBER = 'account_number';
export const COUNTER = 'counter';
export const COUNTER_SETTINGS = 'counter_settings';
export const SEGMENT_MARKET_CODE = 'segment_market_code';
export const RESERVATION_STATES = 'reservation-states';
export const SOURCES = 'sources';
export const ORIGINE_OF_BOOKING = 'origine_of_booking';
export const AEREPORTS = 'aereports';
export const VIP_CATEGORIES = 'vip_categories';
export const LIKES = 'likes';
export const AGE_RANGES = 'age_ranges';
export const ROOM_TYPES = 'room_types';
export const ROOM_CATEGORIES = 'room_categories';
export const ROOM_LISTS = 'room_lists';
export const ROOM_FLOORS = 'room_floors';
export const BLOCS = 'blocs';
export const CHARGE_GROUP = 'charge_group';
export const INVOICE_CHARGE_GROUP = 'invoice_charge_group';
export const CHARGE_CODE = 'charge_code';
export const ITEMS = 'items';
export const BILLING_GROUP = 'billing_group';
export const PACKAGES = 'packages';
export const ADD_ON = 'add_on';
export const DISCOUNT_TYPE = 'discount_type';
export const SECTIONS = 'sections';
export const STATE = 'state';
export const HOUSE_KEEPER = 'house_keeper';
export const MAINTENANCE_TYPE = 'maintenance_type';
export const WORK_TYPE = 'work_type';
export const WORK_TASK = 'work_task';
export const RANGE_TEMPLATE = 'range_template';
export const PROMOTION_AND_CHARGE_RULES = 'promotion_and_charge_rules';
export const RULES_AND_RESTRICTIONS = 'rules_and_restrictions';
export const RATE_TYPE = 'rate_type';
export const FREQUENCY = 'frequency';
export const SEASON = 'season';
export const BOARDS = 'boards';
export const BOARD_SERVICE_SETTINGS = 'board-service-settings';
export const COMPLIMENTARY_CATEGORY = 'complimentary-category';

export const COMPANY_TA_CARDS_GROUP = 'company_ta_cards_group';
export const GUEST_CARD_FILEDS = 'guest_card_fileds';
/** BILLING MANAGER */
export const BILLING_MANAGER = 'billing_manager';
export const MOVE_PAYMENT = 'move_payment';
export const POST_NEGATIVE_CHARGE = 'post_negative_charge';
export const POST_NEGATIVE_PAYMENT = 'post_negative_payment';
export const MOVE_CHARGE = 'move_charge';

/** FRONT DESK MANAGER */
export const FRONT_DESK_MANAGER = 'front_desk_manager';
export const CHECK_IN = 'check_in';
export const CHECK_OUT = 'check_out';
export const CANCEL = 'cancel';
export const UNDO_CHECK_IN = 'undo_check_in';
export const UNDO_CHECK_OUT = 'undo_check_out';
export const DUPLICATE = 'duplicate';

export const EDIT_DEPARTURE = 'edit_departure';
export const SHOW_DETAILS = 'show_details';
export const EDIT_MARKET_CODE = 'edit_market_code';
export const DO_CHECKOUT = 'do_checkout';
export const DO_EARLY_CHECKOUT = 'do_early_checkout';
